module.exports = __webpack_public_path__ + "img/20.3d8dd81f.jpg";